module.exports = __webpack_public_path__ + "img/express-consign-miniapp.c8290f5.webp";